export const DROPDOWN_DEFAULT_ALIGN = 'start' as const
export const DROPDOWN_DEFAULT_OFFSET = 8
export const DROPDOWN_DEFAULT_MOBILE_BREAKPOINT = 768
export const DROPDOWN_DEFAULT_TITLE_KEY = 'Chat.Dropdown.Title'
